import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import {
  StockReserveVsAvailableDto
  // StockReserveVsAvailableFilterDto
} from '../types'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import { Filter } from '../../_WMS/FilterComponent/types'

export const getReserveAvaiable = (
  filters?: Filter[],
  orderBy?: GenericOrderBy<StockReserveVsAvailableDto>,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.StockApi}/GetStockReserveVsAvailableWMS`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  return axios.get(url.toString())
}
